module.exports = __webpack_public_path__ + "static/media/care_hawaii_group_photo.4f72d0c0.jpg";